import { useLocation } from "react-router-dom";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import Table from "../../../components/table/Table";
import { OptionValueChangeHeaderName } from "../../../components/tableHeaderNames/HeaderName";
import {
  optionValueChangeCallDesc,
  optionValueChangePutDesc,
} from "../../../components/description/data";
import { useMarketWatchOptionContext } from "../../../context/market-watch/MarketWatchOptionContext";

const MarketWatchSingleOption = () => {
  const { pathname } = useLocation();
  const { valueChangeTableData, valueChagneHighlightedCols } =
    useMarketWatchOptionContext();

  const routeConfigs = {
    "/dashboard/market-watch/options/call_value_change": {
      tableData: valueChangeTableData,
      tableTitle: {
        title: "ارزش آپشن های خرید",
        desc: optionValueChangeCallDesc,
      },
      highlightedCols: valueChagneHighlightedCols,
      faCols: OptionValueChangeHeaderName,
    },
    "/dashboard/market-watch/options/put_value_change": {
      tableData: valueChangeTableData,
      tableTitle: {
        title: "ارزش آپشن های فروش",
        desc: optionValueChangePutDesc,
      },
      highlightedCols: valueChagneHighlightedCols,
      faCols: OptionValueChangeHeaderName,
    },
  };
  const tableProps = {
    isActions: true,
    height: "80vh",
    ...routeConfigs[pathname],
  };

  return (
    <Grid2 container>
      <Grid2 xs={12}>
        <Table {...tableProps} />
      </Grid2>
    </Grid2>
  );
};

export default MarketWatchSingleOption;
